import type { SupportCenterTriageStatus } from '../../types/supportCenterTriage'

export function primaryClientEmail(emails: string[] | undefined): string {
  return emails?.find((e) => e.trim())?.trim() || '—'
}

export function statusBadgeClass(status: SupportCenterTriageStatus): string {
  if (status === 'pendente') {
    return 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300'
  }
  if (status === 'concluida') {
    return 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300'
  }
  if (status === 'nao_realizado') {
    return 'bg-slate-100 text-slate-800 dark:bg-slate-800/50 dark:text-slate-300'
  }
  // reprovado | cancelado
  return 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300'
}

export function isTriageClosedWithoutAttendance(status: SupportCenterTriageStatus): boolean {
  return status === 'reprovado' || status === 'cancelado'
}

export function triageColumnBadgeClass(
  status: SupportCenterTriageStatus | null | undefined
): string {
  if (!status) {
    return 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300'
  }
  return statusBadgeClass(status)
}
